import React, { Component } from "react"
import { withTranslation } from "react-i18next";
import './Error.scss';

class Error extends Component {  

  messageColour = (type) => type==="successMessage" ? "" : "error";

  errorDisplay = () => {
    const { t, type } = this.props;
    const error = t(`errors#${type}`)
    const errorHasLink = error.includes('/n');
    let errorArr = error.split('/n');
    if (errorHasLink) {
      if (type==="successMessage") {
        const [ errorText, link ] = errorArr;
          return <div>
            <p className={this.messageColour(type)}>{errorText}</p> 
            <div className="text-end">
              <button className="button" onClick={() => { window.location.href = t(`GHPLink`) }}>
                {link}
              </button>
            </div>
          </div>
      } else {
        const [ firstSection, link, secondSection ] = errorArr;
        if (link.includes('@')) {
          return <p className={this.messageColour(type)}>{firstSection}<a className="errorLink" href={`mailto:${link}`}>{link}</a>{secondSection}</p> 
        } else {
          return <p className={this.messageColour(type)}>{firstSection}<a className="errorLink" href={t(`GHPLink`)} target="blank">{link}</a>{secondSection}</p> 
        }
      }
    } else {
      return <p className={this.messageColour(type)}>{error}</p>;
    }
  }
  
    render() {
      return (
          <div className="container consent-container p-5">
            {this.errorDisplay()}
          </div>
      );
    }
  }
export default withTranslation()(Error);